<template>
	<div class="page_warp">
		<div class="top_content">
			<div class="top_input">
				<el-input v-model="searchWord" placeholder="请输入"></el-input>
			</div>
			<div class="search_btn" @click="getData">查询</div>
			<div v-if="permissionItem.export" class="search_btn" @click="exportClick()">导出</div>
		</div>
		<div class="bottom_content">
			<div class="table_container" v-bind:id="tableId">
				<el-table v-bind:data="tableData" stripe border style="width: 100%" v-bind:max-height="tableHeight"
					v-bind:header-cell-style="{
            textAlign: 'center',
            color: '#333333',
            background: '#F5F5F5',
          }" v-bind:cell-style="{ textAlign: 'center' }" empty-text="暂无数据">
					<!-- <el-table-column prop="roleId" label="角色ID"></el-table-column> -->
					<el-table-column fixed prop="lineId" label="路线编号" width="120"></el-table-column>
					<el-table-column fixed prop="loadWhNames" label="装货地" width="120"></el-table-column>
					<el-table-column fixed prop="unlWhNames" label="卸货地" width="120"></el-table-column>
					<el-table-column prop="odrCount" label="历史运行次数" width="120"></el-table-column>
					<el-table-column prop="avgLoadDuration" label="装货平均耗时" width="120">
						<template #default="scope">
							<span>{{timeDeltaCount(scope.row.avgLoadDuration)}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="avgUnlDuration" label="卸货平均耗时" width="120">
						<template #default="scope">
							<span>{{timeDeltaCount(scope.row.avgUnlDuration)}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="avgUnlDuration" label="平均重车里程" width="120"></el-table-column>
					<el-table-column prop="avgTravelDuration" label="在途平均耗时" width="120">
						<template #default="scope">
							<span>{{timeDeltaCount(scope.row.avgTravelDuration)}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="avgSumDuration" label="平均总耗时" width="120">
						<template #default="scope">
							<span>{{timeDeltaCount(scope.row.avgSumDuration)}}</span>
						</template>
					</el-table-column>
					<el-table-column prop="avgFreewayCost" label="平均高速费" width="120"></el-table-column>
					<el-table-column prop="avgTollCost" label="平均路桥费" width="120"></el-table-column>
					<el-table-column prop="avgFuelCost" label="平均燃料费" width="120"></el-table-column>
					<el-table-column prop="avgSumCost" label="平均总成本" width="120"></el-table-column>
					<el-table-column prop="avgFreightMoney" label="平均运费收入" width="120"></el-table-column>
					<el-table-column prop="avgSumIncome" label="平均运输利润" width="120"></el-table-column>
					<el-table-column prop="lineDefSet.olseDefDuration" label="标准耗时" width="120"></el-table-column>
					<el-table-column prop="lineDefSet.olseDefGas" label="标准气耗" width="120"></el-table-column>
					<el-table-column prop="lineDefSet.olseDefFuel" label="标准油耗" width="120"></el-table-column>
					<el-table-column prop="lineDefSet.olseDefTollCost" label="标准路桥费" width="120"></el-table-column>
					<el-table-column prop="lineDefSet.olseDefFreewayCost" label="标准高速费" width="120"></el-table-column>

					<el-table-column prop="lineDefSet.olseCretime" label="创建时间" width="120"></el-table-column>
					<el-table-column label="操作" fixed="right">
						<template #default="scope">
							<span v-if="permissionItem.list" class="default_color pointer m-right10"
								v-on:click="detail(scope.row.lineId)">详情</span>
						</template>
					</el-table-column>
				</el-table>
			</div>
			<div class="flex flex-y-center flex-x-center">
				<el-config-provider :locale="locale">
					<el-pagination background v-model:currentPage="page" v-model:page-size="pageSize"
						:page-sizes="[5, 10, 15, 20]" layout="sizes, prev, pager, next, total, jumper"
						:total="totalCount" @size-change="getData" @current-change="getData" />
				</el-config-provider>
			</div>
		</div>

		<!-- <Add ref="addRef" v-if="isAdd" @getData="getData" />
		<Edit ref="editRef" v-if="isEdit" @getData="getData" /> -->
		<Detail ref="detailRef" v-if="isDetail" @getData="getData" />
		<!-- <div class="menuManagemen" v-if="isAdd">
      <Add :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isEdit">
      <Edit :sendData="sendData" @closeModal="closeModal" @getData="getData" />
    </div>
    <div class="menuManagemen" v-if="isDetail">
      <Detail
        :sendData="sendData"
        @closeModal="closeModal"
        @getData="getData"
      />
    </div> -->
	</div>
</template>

<script>
	import {
		computed,
		defineComponent,
		reactive,
		toRefs,
		nextTick,
		onMounted,
		getCurrentInstance,
	} from "vue";
	import {
		useStore
	} from "vuex";
	import {
		apiObj
	} from "@/config/api";
	// import Add from "./components/add";
	// import Edit from "./components/edit";
	import Detail from "./components/detail";
	import zhCn from "element-plus/es/locale/lang/zh-cn";
	export default defineComponent({
		components: {
			// Add,
			// Edit,
			Detail
		},
		name: "lineManage",
		setup() {
			const store = useStore();
			const {
				proxy
			} = getCurrentInstance();

			const data = reactive({
				tableId: "roleManagementTable",
				page: 1,
				pageSize: 10,
				searchWord: "",
				totalCount: 0,
				tableData: [],
				tableHeight: 0,
				isAdd: false,
				isEdit: false,
				isDetail: false,
				sendData: null,
				locale: zhCn,

				permissionItem: {
					list: false,
					del: false,
					set: false,
					export: false,
				},
			});
			onMounted(() => {
				let perms = proxy.$storage.get("perms");
				perms.forEach((el) => {
					if (el == "lineManage:list") {
						data.permissionItem.list = true;
					}
					if (el == "lineManage:del") {
						data.permissionItem.del = true;
					}
					if (el == "lineManage:set") {
						data.permissionItem.set = true;
					}
					if (el == "lineManage:export") {
						data.permissionItem.export = true;
					}
				});


				console.log(store.state.userInfo);
				nextTick(() => {
					data.tableHeight =
						document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight - 40;
					getData();
				});
				window.onresize = () => {
					nextTick(() => {
						var offsetHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
						if (offsetHeight <= 0) {
							return false;
						}
						data.tableHeight = document.querySelector(
							".bottom_content .table_container#" + data.tableId
						).offsetHeight;
					});
				};
			});
			//获取列表数据
			const getData = async () => {
				if (!data.permissionItem.list) {
					proxy.$message.error("没有查询线路列表权限！");
					return;
				}

				let params = {
					page: data.page,
					limit: data.pageSize,
					lineId: '', //路线编号
					orgId: '', //所属机构
					odrType: '', //路线类型：0LNG运单路线，1物流运单路线
					lineType: '', //路线装卸类型：0一装一卸，1一装多卸，2多装一卸，3多装多卸
					loadWhid: '',
					unlWhid: '',
				};
				const r = await proxy.$http.get(apiObj.lineList, params);
				console.log(r);
				if (r.code === 0) {
					data.tableData = r.rows;
					data.totalCount = r.total;
				}
			};

			// // 添加 根目录
			// const add = () => {
			// 	data.isAdd = true;
			// 	nextTick(() => {
			// 		proxy.$refs.addRef.init();
			// 	});
			// };

			// // 菜单编辑
			// const edit = (id) => {
			// 	data.isEdit = true;
			// 	nextTick(() => {
			// 		proxy.$refs.editRef.init(id);
			// 	});
			// };
			// 菜单详情
			const detail = (id) => {
				if (!data.permissionItem.list) {
					proxy.$message.error("没有查询线路列表权限！");
					return;
				}

				data.isDetail = true;
				nextTick(() => {
					proxy.$refs.detailRef.init(id);
				});
			};

			//导出数据
			const exportClick = async () => {
				if (!data.permissionItem.export) {
					proxy.$message.error("没有线路导出权限！");
					return;
				}

				let params = {
					page: data.page,
					limit: data.pageSize,
					lineId: '', //路线编号
					orgId: '', //所属机构
					odrType: '', //路线类型：0LNG运单路线，1物流运单路线
					lineType: '', //路线装卸类型：0一装一卸，1一装多卸，2多装一卸，3多装多卸
					loadWhid: '',
					unlWhid: '',
				};
				const r = await proxy.$http.downloadPostFormData(apiObj.exportLineRec, params, "线路数据");
				console.log(r);

			};

			const timeDeltaCount = function(time) {
				if (time) {
					var s = time % 60;
					var m = Math.floor(time / 60) % 60;
					var h = Math.floor(Math.floor(time / 60) / 60);

					if (h !== 0) {
						return h + "小时" + m + "分";
					}
					if (m !== 0) {
						return m + "分";
					}
					return s + "秒";
				} else {
					return ''
				}
			};

			return {
				...toRefs(data),
				getData,
				// add,
				// edit,
				detail,
				exportClick,
				timeDeltaCount
			};
		},
	});
</script>

<style scoped>
	.page_warp {
		width: 100%;
		height: 100%;
	}
</style>